import { AI_EMAIL_TEMPLATE } from '@mm/api-routes';
import { AIEmailTemplate } from '../interfaces/aiEmailTemplates';
import AuthenticatedController from './AuthenticatedController';

export default class AIEmailTemplatesController extends AuthenticatedController {
  static async getOne(facebookPageId: number): Promise<AIEmailTemplate | null> {
    const path = AI_EMAIL_TEMPLATE(facebookPageId);
    return super.get(path);
  }
}
